import { render, staticRenderFns } from "./RegistrationSteps.vue?vue&type=template&id=4e337e50"
import script from "./RegistrationSteps.vue?vue&type=script&lang=js"
export * from "./RegistrationSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports